import type { ApiPipeline, AssociationIds } from "avvir";

import loadFloorPipelines from "../react_query/floors/load_pipelines_for_floor";
import ProcessStatus from "../../models/domain/enums/process_status";
import runPipeline from "../run_pipeline";

import type { ApiFailureEvent } from "../../events/notifications/failure_notifications/api_failure";
import type { AvvirThunk } from "../make_eventful_action";
import type Pipeline from "../../models/domain/pipeline";

type ReturnThunk = AvvirThunk<Promise<ApiPipeline>, ApiFailureEvent>;


export default function triggerQaStatisticsPipeline({ projectId, floorId, scanDatasetId }: AssociationIds): ReturnThunk {
  return (dispatch, getState) => {
    return dispatch(loadFloorPipelines(projectId, floorId)).then((pipelines: Pipeline[]) => {
      let runningQaPipeline = pipelines.find(pipeline => {
        return pipeline.name === "compute-qa-statistics" &&
               pipeline.firebaseScanDatasetId === scanDatasetId &&
               pipeline.status === ProcessStatus.RUNNING;
      });
      if (runningQaPipeline == null) {
        return runPipeline({
          name: "compute-qa-statistics",
          firebaseProjectId: projectId,
          firebaseFloorId: floorId,
          firebaseScanDatasetId: scanDatasetId,
        })(dispatch, getState);
      } else {
        return null;
      }
    });
  };
}
